import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import { ChevronDownIcon, SettingsIcon } from '@chakra-ui/icons';
import { Box, Button, Flex, Menu, MenuButton, MenuList, MenuItem } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { isChatAdmin } from '../../../utils/user/user';
import { changeRole, kickParticipant, openModal, Modals } from '../../../redux/reducers';

const Participant = ({
  participantId,
  name,
  type,
  currentUserIsAdmin,
  isCurrentUser,
  setUserType,
  removeUser,
  onClick,
}) => {
  const { t } = useTranslation();
  const menuItems = [
    { type: 'deaf', i18nKey: 'common.usertype.deaf' },
    { type: 'interpreter', i18nKey: 'common.usertype.interpreter' },
    { type: 'hears', i18nKey: 'common.usertype.hears' },
  ];

  const getTypeTranslation = (type) => {
    const item = menuItems.find((item) => item.type === type);
    return item && item.i18nKey && t(item.i18nKey);
  };
  if (!isCurrentUser && currentUserIsAdmin) {
    return (
      <Menu bg="brand.10">
        {() => (
          <>
            <Flex>
              <Box onClick={() => onClick()}>
                {name}
                {type && ', ' + getTypeTranslation(type)}
              </Box>
              <MenuButton>{<ChevronDownIcon />}</MenuButton>
            </Flex>
            {}
            <MenuList color="black">
              {menuItems.map((item, index) => (
                <MenuItem key={'menuUserType' + index} onClick={() => setUserType(name, item.type)}>
                  {getTypeTranslation(item.type)}
                </MenuItem>
              ))}
              <MenuItem
                color="brand.60"
                fontWeight="bold"
                onClick={() => removeUser(participantId, name)}
              >
                <Trans i18nKey="chat.removeFromConversation" />
              </MenuItem>
            </MenuList>
          </>
        )}
      </Menu>
    );
  } else {
    return (
      <Box>
        {name}
        {type && ', ' + getTypeTranslation(type)}
      </Box>
    );
  }
};

Participant.propTypes = {
  participantId: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  setUserType: PropTypes.func,
  removeUser: PropTypes.func,
  currentUserIsAdmin: PropTypes.bool,
  isCurrentUser: PropTypes.bool,
  onCLick: PropTypes.func,
};

export const Participants = ({ members }) => {
  const roles = useSelector((state) => state.activeSession.roles);
  const dispatch = useDispatch();

  const participants = members.map((m) => ({
    id: m.id,
    name: m.name,
    type: roles[m.name],
    isCurrentUser: m.isSelf,
  }));

  const { userData } = useSelector((state) => state.user);
  const currentUserIsAdmin = isChatAdmin(userData);
  const setUserType = useCallback((name, role) => dispatch(changeRole(name, role)), [dispatch]);
  const removeUser = useCallback(
    async (participantId, name) => {
      dispatch(kickParticipant(participantId, name));
    },
    [dispatch]
  );
  const openSettings = useCallback(() => {
    dispatch(openModal({ mode: 'chat' }, Modals.SETTINGS));
  }, [dispatch]);

  return (
    <Box>
      <Box sx={{ float: 'right' }}>
        <Button bg="null" m={0} p={0} onClick={openSettings}>
          <SettingsIcon w={6} h={6} mr={1} />
        </Button>
      </Box>

      <Box my="2" fontWeight="bold">
        <Trans i18nKey="chat.participants" />
      </Box>
      <Box my="2">
        {participants.map((item, index) => (
          <Box key={'participants ' + index}>
            <Participant
              participantId={item.id}
              name={item.name}
              type={item.type}
              setUserType={setUserType}
              removeUser={removeUser}
              currentUserIsAdmin={currentUserIsAdmin}
              isCurrentUser={item.isCurrentUser}
              onClick={() => {}}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

Participants.propTypes = {
  members: PropTypes.array,
};
